import { render, staticRenderFns } from "./ProducerView.vue?vue&type=template&id=9227157e&scoped=true&"
import script from "./ProducerView.vue?vue&type=script&lang=js&"
export * from "./ProducerView.vue?vue&type=script&lang=js&"
import style0 from "./ProducerView.vue?vue&type=style&index=0&id=9227157e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9227157e",
  null
  
)

export default component.exports